// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.darkmode .cancel-selectbox .vs__search {\n  color: white;\n}\n.custom-dropdown-menu {\n  width: 170px !important;\n}\n", ""]);
// Exports
module.exports = exports;
